import { render, staticRenderFns } from "./JerseyButtonRed.vue?vue&type=template&id=5107c948&scoped=true&"
import script from "./JerseyButtonRed.vue?vue&type=script&lang=ts&"
export * from "./JerseyButtonRed.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyButtonRed.vue?vue&type=style&index=0&id=5107c948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107c948",
  null
  
)

export default component.exports